<template>
  <div>
    <div class="sticky-top">
      <SiteHead v-bind:mode="mode" />
      <Broadcasting class="mx-4"
        v-bind:config="config"
        v-bind:broadcasting="saved.broadcasting"
        v-bind:joined="saved.joined"
        v-bind:waiting="saved.waiting"
        v-bind:others="saved.others"
        v-bind:game="game"
        />
    </div>
    <main class="mx-4">
      <LobbyJoined class="mt-2" ref="joined"
        v-bind:config="config"
        v-bind:joined="saved.joined"
        v-bind:others="saved.others"
        v-on:change-entries="onChangeEntries"
        />
      <LobbyWaiting class="mt-2" ref="waiting"
        v-bind:config="config"
        v-bind:joined="saved.joined"
        v-bind:waiting="saved.waiting"
        v-bind:history="saved.history"
        v-on:add-to-joined="onAddJoined"
        v-on:add-waiting="onAddWaiting"
        v-on:change="onWaitingChange"
        v-on:change-entries="onChangeEntries"
        />
      <MemberHistory class="mt-2" ref="history"
        v-bind:config="config"
        v-bind:waiting="saved.waiting"
        v-bind:history="saved.history"
        v-on:add-to-waiting="onHistoryToWaiting"
        v-on:change="onHistoryChange"
        v-on:change-entries="onChangeEntries"
        />
      <SettingsForBroadcast class="mt-2"
        v-bind:config="config"
        v-bind:others="saved.others"
        v-on:change="onOthersChange"
        />
      <SettingsForCamera class="mt-2"
        v-bind:settingForCamera="saved.settingForCamera"
        v-on:start-quest="onStartQuest"
        v-on:return-quest="onReturnQuest"
        v-on:update-camera-status="onUpdateCameraStatus"
        v-on:change="onChangeSettingsForCamera"
        />
      <SettingsForYouTube class="mt-2"
        v-model="saved.settingsForYouTube"
        v-on:reserve-member="onAddWaitingFromChat"
        v-on:cancel-member="onCancelWaitingFromChat"
        v-on:change-hunter-name="onChangeHunterName"
        />
      <UserData class="mt-2"
        v-bind:saved="saved"
        />
      <SiteTail/>
      <!--
      <pre>{{$data}}</pre>
      -->
    </main>
  </div>
</template>

<script>
import Vue from 'vue'
import Toasted from 'vue-toasted'

import SiteHead from '@/components/layouts/SiteHead.vue'
import SiteTail from '@/components/layouts/SiteTail.vue'

import Broadcasting from '@/components/Broadcasting.vue'
import LobbyJoined from '@/components/LobbyJoined.vue'
import LobbyWaiting from '@/components/LobbyWaiting.vue'
import MemberHistory from '@/components/MemberHistory.vue'
import SettingsForBroadcast from '@/components/SettingsForBroadcast.vue'
import SettingsForCamera from '@/components/SettingsForCamera.vue'
import SettingsForYouTube from '@/components/SettingsForYouTube.vue'
import UserData from '@/components/UserData.vue'

import Migration from '@/components/resource/Migration'
import Storage from '@/components/resource/Storage'

import _ from 'lodash'

Vue.use(Toasted, {
  position: 'bottom-right',
  duration: 3 * 1000,
})

export default {
  components: {
    SiteHead,
    Broadcasting,
    LobbyJoined,
    LobbyWaiting,
    MemberHistory,
    SettingsForBroadcast,
    SettingsForCamera,
    SettingsForYouTube,
    UserData,
    SiteTail,
},
  data() {
    return {
      dataVersion: 8,
      config: {
        maxJoinedMemberCount: 4,
        maxWaitingMemberCount: 20,
        broadcasting: {
          joinedListSpace: 5,
          waitingMemberSliceCount: 4,
        },
        others: {
          defaultColor: '#000000',
          defaultNameColor: '#000000',
          defaultBackgroundColor: '#FFFFFF',
          initialColor: '#FFFFFF',
          initialNameColor: '#FFFF00',
          initialTransparentColor: '#00FF00',
          initialBackgroundColor: '#000000',
          initialTextShadowColor: '#000000',
          initialGuestNameSuffix: 'さん',
        },
      },
      saved: {
        broadcasting: {
          panelOpened: false,
          displayJoinedListInLobby: true,
          displayJoinedListInQuest: true,
          displayWaitingListInLobby: true,
          displayWaitingListInQuest: true,
        },
        joined: {
          panelOpened: true,
          duringQuest: false,
          members: [],
          questHost: undefined,
          lastQuestHost: undefined,
          displayOrder: 'manual',  // display, joined, manual
          questHostTypes: {
            'host': true,
            'support': true,
            'guest': true,
          },
          questHostOrder: 'manual',  // display, joined, manual
          questHostAlter: 'next',
          lockHostAndSupport: false,
          lockDuringQuest: true,
        },
        waiting: {
          panelOpened: true,
          members: [],
        },
        history: {
          panelOpened: false,
          members: [],
        },
        others: {
          panelOpened: false,
          maskEnabled: false,
          color: '#FFFFFF',
          nameColor: '#FFFF00',
          transparentColor: '#00FF00',
          backgroundColor: '#000000',
          fontFamilyEnabled: false,
          fontFamily: '',
          textShadowEnabled: false,
          textShadowColor: '#000000',
          questHostIconEnabled: false,
          questHostIconImage: '',
          guestNameSuffixEnabled: false,
          guestNameSuffix: 'さん',
        },
        settingForCamera: {
          panelOpened: false,
          videoDeviceEnabled: false,
          videoDeviceId: '',
        },
        settingsForYouTube: {
          panelOpened: false,
          enabled: false,
          url: '',
          commandPlace: 'any',
          commandToReserve: '参加希望 参加予約 /yoyaku',
          commandToCancel: '参加取消 予約取消 辞退 /torikeshi',
          hunterNameSeparator: 'bracket',
          excludedKeyword: '※これは例です',
        },
      },
      game: {
        infoDisplayOnRightSide: false,
      },
    }
  },
  created() {
    this.saved = _.merge(this.saved, Storage.load())
    
    // migrate data schema
    this.saved = Migration.migrate(this.dataVersion, this.saved)

    // set lobby host object reference
    if (this.saved.joined.lobbyHost) {
      this.saved.joined.lobbyHost = this.saved.joined.members.find(m => m.name == this.saved.joined.lobbyHost.name)
    }

    // set quest host object reference
    if (this.saved.joined.questHost) {
      this.saved.joined.questHost = this.saved.joined.members.find(m => m.name == this.saved.joined.questHost.name)
    }

    // set last quest host object reference
    if (this.saved.joined.lastQuestHost) {
      this.saved.joined.lastQuestHost = this.saved.joined.members.find(m => m.name == this.saved.joined.lastQuestHost.name)
    }
  },
  watch: {
    'saved': {
      handler() {
        Storage.save(this.saved)
      },
      deep: true,
    },
  },
  computed: {
    mode() {
      return process.env.VUE_APP_MODE ?? ''
    }
  },
  methods: {
    onAddJoined(entry) {
      let h = this.saved.history.members.find(m => m.name == entry.name)
      this.$refs.joined.addJoined({
        ...entry,
        ...{
          grandTotalSortieCount : h ? h.grandTotalSortieCount : 0,
          totalSortieCount: h ? h.totalSortieCount : 0,
        }
      })
    },
    onAddWaiting(entries) {
      this.$refs.history.addHistory(entries)
    },
    onAddWaitingFromChat(entries) {
      this.$refs.waiting.addWaitingFromChat(entries)
    },
    onCancelWaitingFromChat(entries) {
      this.$refs.waiting.removeWaitingFromChat(entries)
    },
    onChangeHunterName(entries) {
      let changes = entries.filter(entry =>
        this.saved.joined.members.some(m => m.name == entry.name) ||
        this.saved.waiting.members.some(m => m.name == entry.name) ||
        this.saved.history.members.some(m => m.name == entry.name))
      if (changes.length == 0) return

      this.$refs.joined.changeHunterNameFromChat(entries)
      this.$refs.waiting.changeHunterNameFromChat(entries)
      
      changes.forEach(change => {
        this.$toasted.info(`ハンター名を設定しました: ${change.name} → ${change.hunterName}`, {duration: 10 * 1000})
      })
    },
    onWaitingChange(waiting) {
      this.saved.waiting = waiting
    },
    onHistoryToWaiting(members) {
      this.$refs.waiting.addWaiting(members)
    },
    onHistoryChange(history) {
      this.saved.history = history
    },
    onOthersChange(others) {
      this.saved.others = others
    },
    onChangeEntries(entries) {
      this.$refs.joined.changeEntries(entries)
      this.$refs.waiting.changeEntries(entries)
      this.$refs.history.changeEntries(entries)
    },
    onStartQuest() {
      this.$refs.joined.onStartQuest()
    },
    onReturnQuest() {
      this.$refs.joined.onReturnQuest()
    },
    onUpdateCameraStatus(status) {
      this.$set(this.game, 'infoDisplayOnRightSide', status.infoDisplayOnRightSide)
    },
    onChangeSettingsForCamera(settingForCamera) {
      this.saved.settingForCamera = settingForCamera
    }
  }
}
</script>
